"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _seamlessImmutable = require("seamless-immutable");
var _constants = require("../actions/constants");
const getInitialState = () => ({
  conversationInfo: {},
  isAbcSupported: false,
  isPolling: false,
  previousPathName: null,
  status: 0
});
const liveChatReducer = function () {
  let oldState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getInitialState();
  let action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const state = _seamlessImmutable.static.from(oldState);
  const reducers = {
    [_constants.LIVECHAT_ABC_SUPPORTED]: () => _seamlessImmutable.static.set(state, 'isAbcSupported', action.payload),
    [_constants.LIVECHAT_CONVERSATION_INFO]: () => _seamlessImmutable.static.set(state, 'conversationInfo', action.data),
    [_constants.LIVECHAT_POLLING_START]: () => _seamlessImmutable.static.set(state, 'isPolling', true),
    [_constants.LIVECHAT_POLLING_STOP]: () => _seamlessImmutable.static.set(state, 'isPolling', false),
    [_constants.LIVECHAT_STATUS]: () => _seamlessImmutable.static.set(state, 'status', action.status),
    [_constants.PREVIOUS_PATH_NAME_CHANGE]: () => _seamlessImmutable.static.set(state, 'previousPathName', action.previousPathName)
  };
  return reducers[action.type] ? reducers[action.type]() : state;
};
var _default = liveChatReducer;
exports.default = _default;